<template>
  <div>
    <b-link href="#" v-b-toggle.more-info>
      <span class="when-closed">More info</span>
      <span class="when-opened">Hide info</span>
    </b-link>
    <b-collapse id="more-info" class="mt-3">
      <h5>What is Hugster?</h5>
      <p>A large share of the world is practising social distancing at the moment (April 2020) to slow the spread of the COVID-19 pandemic. Not meeting anybody face to face for such long stretches of time is incredibly disruptive for many. We may forget to keep in touch with people we would see regularly under normal circumstances.</p>
      <p>Hugster texts you a daily gentle reminder to reach out to one of your friends, family, coworkers, co-conspirators.</p>
      <h5>Does this work in my country?</h5>
      <p>Yes, in theory we can send texts to any mobile number in the world. <strong>Texts come from a US number.</strong> Check that your mobile provider allows texts from the US and doesn't charge you extra.</p>
      <p>During sign up you need to verify that you can receive a text from us so you'll know quickly if your number works.</p>
      <h5>What do you do with my data?</h5>
      <p>We will use your phone number only to text you and will never share it with anybody. We will never share your contacts' data with somebody other than you.</p>
      <p>You can delete your account at any point in time - find the link in the top right corner. Caution: This will delete all your data unrecoverably.</p>
      <h5>How can I stop texts?</h5>
      <p>You can disable text messages in the settings tab at the bottom.</p>
      <h5>Questions? Comments?</h5>
      <p>Get a bit more <a href="http://blog.nikhaldimann.com/2020/04/08/lockdown-hacks/" target="_blank">background</a> or email me at nhaldimann AT gmail DOT com.</p>
      <p>
        <b-link href="#" v-b-toggle.more-info>
          <span class="when-closed">More info</span>
          <span class="when-opened">Hide info</span>
        </b-link>
      </p>
    </b-collapse>
  </div>
</template>

<script>
import { BButton, BCollapse, BLink } from 'bootstrap-vue'

export default {
  components: {
    'b-button': BButton,
    'b-collapse': BCollapse,
    'b-link': BLink
  }
}
</script>

<style scoped>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
h5 {
  font-size: 1rem;
  font-weight: bold;
  color: #999;
  margin-bottom: 0.2rem;
  margin-top: 1.8rem;
}
</style>
